import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isAgentPage } from '../../helpers/router.helper';
import { FeeCalculationFacade } from '../../state/fee-calculation/fee-calculation.facade';

@Component({
    selector: 'property-price-notice',
    templateUrl: './property-price-notice.component.html'
})
export class PropertyPriceNoticeComponent implements OnInit {
    showMessage = false;
    constructor(private feeCalculationFacade: FeeCalculationFacade, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.feeCalculationFacade.isIncreasePricingTier$
        .subscribe(isIncreasePricingTier => {
            this.showMessage = isIncreasePricingTier && !isAgentPage(this.route, true);
        });
    }
}
